import React, {useEffect, useRef, useState} from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {sendRequestQuduq} from "../../api/request";

const ModalQidirish = ({type}) => {
    const [loading, setLoading] = useState(true)
    const [argument, setArgument] = useState('')
    const [dataone, setDataone] = useState('')
    const inputRef = useRef();

    const dayHandler = () => {
        const getDataOne = async () => {
            try {
                await sendRequestQuduq({
                    url: `qidirish?arg=${argument}`,
                    method: "POST",
                }).then((res) => {
                    if (res) setLoading(true)
                    setDataone(res.data[0])
                });
            } catch (e) {
                console.log(e)
            }
        }
        getDataOne()
    }

    return (
        <div className="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
            <div className="modal-dialog modal-xl">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="staticBackdropLabel">Dayver</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <form>
                            {
                                type
                                ? <div className="mb-3 px-md-5">
                                        <div className="d-flex justify-content-center">
                                            <input type="date" className="form-control" style={{maxWidth: "300px"}} />
                                            <button type="button" className="ms-2 btn btn-info"><FontAwesomeIcon icon="fa-solid fa-magnifying-glass" /> Qidirish</button>
                                        </div>
                                    </div>
                                : <div className="mb-3 px-md-5">
                                        <div className="d-flex justify-content-center">
                                            <input ref={inputRef} onChange={() => setArgument(inputRef.current.value)} value={argument} type="text" className="form-control" placeholder="KOD yoki IMEI kiriting..." style={{maxWidth: "300px"}} />
                                            <button onClick={dayHandler} type="button" className="ms-2 btn btn-info"><FontAwesomeIcon icon="fa-solid fa-magnifying-glass" /> Qidirish</button>
                                        </div>
                                    </div>
                            }
                        </form>
                        {
                            dataone ?
                                <div className="row">
                                    <div className="col-md-8">
                                        <div className="table-responsive">
                                            <table className="table table-bordered table-hover">
                                                <thead className="text-center table-primary align-middle">
                                                <tr>
                                                    <th scope="col" colSpan={10}>{dataone?.obekt}</th>
                                                </tr>
                                                <tr>
                                                    <th scope="col">#</th>
                                                    <th scope="col">Sath</th>
                                                    <th scope="col">Mineral</th>
                                                    <th scope="col">Temperatura</th>
                                                    <th scope="col">Qurulma o'lchagan vaqt</th>
                                                    <th scope="col">IP</th>
                                                </tr>
                                                </thead>
                                                <tbody className="text-center">
                                                <tr>
                                                    <th scope="row">1</th>
                                                    <td>{dataone?.level}</td>
                                                    <td>{dataone?.mineral}</td>
                                                    <td>{dataone?.temperatura}</td>
                                                    <td>{dataone?.sana}</td>
                                                    <td>{dataone?.ip}</td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="card mb-3" >
                                            <div className="card-header bg-warning  text-center "><strong>Qurulma</strong></div>
                                            <div className="card-body text-center">
                                                <h6 className="card-title mb-1">Viloyat: {dataone?.vil_nomi}</h6>
                                                <h6 className="card-title mb-1">Tuman: {dataone?.tum_nomi}</h6>
                                                <h6 className="card-title mb-1">KOD/IMEI: {dataone?.code}</h6>
                                                <h6 className="card-title mb-1">Integratsiya: {dataone?.created_at}</h6>
                                                <h6 className="card-title mb-1">Yil hisobi: {dataone?.made}</h6>
                                                <h6 className="card-title mb-1">Kadastr: {dataone?.cadastr}</h6>
                                                <h6 className="card-title mb-1">Balans tashkilot: {dataone?.name}</h6>
                                                <h6 className="card-title mb-3">Pudratchi: {dataone?.company}</h6>
                                                <h6 className="card-text text-danger"><FontAwesomeIcon color="#dc3545" icon="fa-solid fa-triangle-exclamation" /> Eslatma: Ma'lumotlar pudratchilardan olingan</h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                :
                                <div className="alert alert-danger text-center" role="alert">
                                    <strong><FontAwesomeIcon icon="fa-solid fa-triangle-exclamation" /> KOD yoki IMEIni to'g'ri kiritilishiga axamiyat bering!</strong>
                                </div>
                        }
                    </div>
                    <div className="modal-footer">
                        <button onClick={() => (setDataone(""), setArgument(""))} type="button" className="btn btn-secondary" data-bs-dismiss="modal"><FontAwesomeIcon color="red" icon="fa-solid fa-xmark" /> Yopish</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ModalQidirish;